import type { AxiosResponse } from 'axios';
import UploadService from '.';

type URLType = { url: string };

export type FileUploadType = {
  setFileUpload: (
    idUser: string,
    documentOwner: string,
    fileUser: File,
    field: string,
  ) => Promise<AxiosResponse<URLType>>;
};

function uploadDocument(): FileUploadType {
  const { fileUpload } = UploadService();

  async function setFileUpload(
    id: string,
    documentOwner: string,
    fileUser: File,
    field: string,
  ) {
    const data = new FormData();
    data.append('document_owner', documentOwner);
    data.append('document', fileUser);
    data.append('field', field);

    return fileUpload(id, data);
  }
  return { setFileUpload };
}

export { uploadDocument };
